import { render, staticRenderFns } from "./ListaDeVendasDoFechamento.vue?vue&type=template&id=53b5e960&scoped=true&"
import script from "./ListaDeVendasDoFechamento.vue?vue&type=script&lang=ts&"
export * from "./ListaDeVendasDoFechamento.vue?vue&type=script&lang=ts&"
import style0 from "./ListaDeVendasDoFechamento.vue?vue&type=style&index=0&id=53b5e960&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b5e960",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VChip,VChipGroup,VIcon,VTooltip})
